/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function EnhancedTextAreaController ($element, $timeout, $window) {
	var self = this;
	var isRenderingError = false;
	var textAreaElem;
	var textAreaCloneElem;
	var lineErrorElem;


	//=================//
	// Lifecycle Hooks //
	//=================//

    var formatCharsDisplay = function (modelValue) {
        var length = 0;
        if (modelValue && modelValue.length >= 0) {
            length = modelValue.length;
        }

        var output = '' + (self.maxChars - length);
        while (output.length < 4) {
            output = '0' + output;
        }

        self.charsRemaining = output;
    };

    var onInputChange = function (newValue) {
        formatCharsDisplay(newValue);
        self.errorCharIndex = (self.errorCharIndex !== undefined) ? null : undefined;
        return newValue;
    };

    self.$onInit = function () {
        self.ngModelCtrl.$formatters.push(onInputChange);
        self.ngModelCtrl.$parsers.push(onInputChange);
    };

    self.$postLink = function () {
        lineErrorElem = $element.find('.line-error')[0];
        textAreaElem = $element.find('textarea')[0];
        textAreaCloneElem = textAreaElem.cloneNode();
        textAreaCloneElem.disabled = true;
        textAreaCloneElem.rows = 1;
        textAreaCloneElem.classList.add('anchored-invisible-clone');
        textAreaElem.parentElement.insertBefore(textAreaCloneElem, textAreaElem);
        $timeout(function () {
            formatCharsDisplay(self.value());
        });
    };

    var onRenderError = function () {
        if (Number.isInteger(self.errorCharIndex)) {
            textAreaCloneElem.style.top = textAreaElem.offsetTop + 'px';
            textAreaCloneElem.style.left = textAreaElem.offsetLeft + 'px';
            textAreaCloneElem.style.width = textAreaElem.offsetWidth + 'px';
            let scrollHeight = textAreaCloneElem.scrollHeight;
            if (!textAreaCloneElem.value.length) {
                scrollHeight = 0;
            }
            lineErrorElem.style.top = (scrollHeight - textAreaElem.scrollTop) + 'px';
            $window.requestAnimationFrame(onRenderError);
        } else {
            isRenderingError = false;
        }
    };

    self.$doCheck = function () {
        if (!isRenderingError && self.value() && Number.isInteger(self.errorCharIndex)) {
            var errorStartIndex = self.value().lastIndexOf('\n', self.errorCharIndex);
            if (errorStartIndex >= self.errorCharIndex) {
                errorStartIndex = 0;
            }
            textAreaCloneElem.value = self.value().substring(0, errorStartIndex);
            isRenderingError = true;
            $window.requestAnimationFrame(onRenderError);
        }
    };


	//================//
	// Template Logic //
	//================//

    self.value = function (newValue) {
        if (newValue === undefined) {
            return self.ngModelCtrl.$modelValue;
        }
        self.ngModelCtrl.$setViewValue(newValue);
    };

	self.onFocus = function () {
		self.inputFocused = true;
		formatCharsDisplay(self.value());
	};

	self.onBlur = function () {
		self.inputFocused = false;
	};
}

angular
.module('prism-ui.components')
.component('enhancedTextarea', {
	templateUrl: 'components/visual/enhancedTextArea/enhanced-textarea-template.html',
	controller: EnhancedTextAreaController,
    require: {
        ngModelCtrl: '^ngModel',
    },
	bindings: {
		maxChars: '@',
        errorCharIndex: '=errorIndex',
        disableProp: '=ngDisabled',
		inputId: '@',
		inputRows: '@',
		monospace: '='
	}
});
